export default "/images/312d901c13091819327a0c1361e021ea.avif";